import React from 'react';
import styles from './footer.module.scss';

const Footer: React.FC = () => {
	return (
		<footer>

			<p className={styles.footer}>CSGOdle.net - 2023</p>


		</footer>
	);
};

export default Footer;
